import React from 'react';
import { Paper, Typography, Box, IconButton, List, ListItem, ListItemText } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import { useQueryHistory } from '../../../hooks/useDocs';

interface QueryHistoryProps {
  onSelectQuery: (query: string) => void;
}

const QueryHistory: React.FC<QueryHistoryProps> = ({ onSelectQuery }) => {
  const { history, clearHistory } = useQueryHistory();

  return (
    <Paper sx={{ p: 2, position: 'sticky', top: 20 }}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography variant="h4">Recent Queries</Typography>
        {history.length > 0 && (
          <IconButton
            size="small"
            onClick={clearHistory}
            aria-label="Clear history"
            data-testid="query-history-clear-button"
          >
            <DeleteIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      {history.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No recent queries
        </Typography>
      ) : (
        <List dense>
          {history.map((item) => (
            <ListItem
              key={item.id}
              sx={{
                cursor: 'pointer',
                '&:hover': { bgcolor: '#F8F8F8' },
                borderRadius: 1,
                mb: 0.5,
              }}
              onClick={() => onSelectQuery(item.query)}
              data-testid={`query-history-item-${item.id}`}
            >
              <ListItemText
                primary={item.query}
                primaryTypographyProps={{ variant: 'body2', sx: { fontWeight: 500 } }}
              />
            </ListItem>
          ))}
        </List>
      )}
    </Paper>
  );
};

export default QueryHistory;
